import { defineStore } from 'pinia'
import axios from 'axios';
import { notify } from '@kyvg/vue3-notification';
import { debounce } from 'lodash'


const URL = 'v1/settings/business'

export const useConfigurations = defineStore('configuration', {
    state: () => ({
        business: {},
        loadingPage: false,
        save: false,
    }),

    getters: {
        all: (state) => {
            return state.business
        },
    },

    actions: {
        getBusiness() {
            this.loadingPage = true
            axios
                .get(URL)
                .then((response) => {
                    this.business = response.data.settings
                    if (!this.business.chat_attendance_sort_by) {
                        this.business.chat_attendance_sort_by = 'last_message'
                    }
                })
                .catch(error => {
                    console.error(error)
                    notify({
                        type: 'error',
                        title: 'Oh não!',
                        text: 'Houve um erro nas configurações. Por favor, tente novamente ou acione o suporte.',
                    })
                })
                .finally(() => this.loadingPage = false)
        },


        /**
         * Persiste uma configuração imediatamente (sem debounce).
         *
         * @param {string} setting
         * @param {string|boolean|number|null} value
         * @param {string} type
         * @param {{ skipNotify?: boolean }} [options]
         * @returns {Promise<import('axios').AxiosResponse>}
         */
        saveSettingImmediate(setting, value, type, options = {}) {
            const store = this
            const skipNotify = options.skipNotify === true

            return axios
                .post(`v1/settings/${type}`, { setting, value })
                .then((response) => {
                    if (skipNotify) {
                        store.save = true
                        return response
                    }
                    if (!store.save) {
                        store.save = true
                        return response
                    }
                    notify({
                        type: 'success',
                        title: 'Tudo certo',
                        text: 'Os ajustes foram salvas com sucesso!',
                    })
                    return response
                })
                .catch(e => {
                    console.warn(e)
                    notify({
                        type: 'error',
                        title: 'Oppss...',
                        text: 'Ocorreu um erro ao salvar as configurações',
                    })
                    throw e
                })
        },

        /**
         * @param {string} setting
         * @param {string|boolean|number} value
         * @param {string} type
         * @param {{ skipNotify?: boolean }} [options]
         */
        saveSetting: debounce((setting, value, type, options) => {
            return useConfigurations().saveSettingImmediate(setting, value, type, options)
        }, 1000),
    },
})